import { type ReactNode } from 'react';

import { CardContentLayout } from '../../../components/CardContentLayout';

import { ContentActionsContainer } from './ContentActionsContainer';
import { DescriptionContainer } from './DescriptionContainer';
import { GeoContainer } from './GeoContainer';
import { HeaderContainer } from './HeaderContainer';
import { LabelsContainer } from './LabelsContainer';
import { PriceContainer } from './PriceContainer';
import { PublisherNarrowContainer } from './PublisherNarrowContainer';

export function ContentContainer(): ReactNode {
  return (
    <CardContentLayout
      actions={<ContentActionsContainer />}
      description={<DescriptionContainer />}
      geo={<GeoContainer />}
      header={<HeaderContainer />}
      labels={<LabelsContainer />}
      price={<PriceContainer />}
      publisher={<PublisherNarrowContainer />}
    />
  );
}
